import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUser, faCog, faChevronRight } from '@fortawesome/free-solid-svg-icons'
import { PATH_ADMIN_USER_LIST, PATH_CLIENT_LIST, PATH_CLIENT_FACILITY_LIST, PATH_CLIENT_DOSEMETER_MEASUREMENT_LIST, PATH_CLIENT_MEASUREMENT_REPORT_LIST, PATH_CLIENT_ACCOUNT_LIST } from 'routing/path'

export function Sidebar(props) {
  const { translations } = props;
  const sidebarItemGroups = [
    {
      id: 'clients', name: translations.clients, icon: faUser, sidebarItems: [
        { id: "goToClientList", name: translations.clientList, link: PATH_CLIENT_LIST },
        { id: "goToClientFacilityList", name: translations.clientFacilityList, link: PATH_CLIENT_FACILITY_LIST },
        { id: "goToMeasurementList", name: translations.measurementList, link: PATH_CLIENT_DOSEMETER_MEASUREMENT_LIST },
        { id: "goToMeasurementReportList", name: translations.measurementReportList, link: PATH_CLIENT_MEASUREMENT_REPORT_LIST },
        { id: "goToClientAccountList", name: translations.accountList, link: PATH_CLIENT_ACCOUNT_LIST },
      ]
    },
    {
      id: 'admin', name: translations.administration, icon: faCog, sidebarItems: [
        { id: "goToUserList", name: translations.userList, link: PATH_ADMIN_USER_LIST },
      ]
    }
  ];

  return (
    <nav id="sidebarMenu" className="sidebar d-md-block bg-primary text-white collapse" data-simplebar>
      <div className="sidebar-inner px-4 pt-3">
        <img className="navbar-brand-dark" src="/img/expolon-logo-text-light.svg" alt="" />
        <ul className="nav flex-column">
          {
            sidebarItemGroups.map((val, k) => {
              return <SidebarItemGroup key={k} obj={val} />;
            })
          }
        </ul>
      </div>
    </nav>
  );
}

function SidebarItemGroup(props) {
  const { obj } = props;
  const submenuId = "submenu-" + obj.id
  return (
    <li className="nav-item">
      <span className="nav-link d-flex justify-content-between align-items-center" data-bs-toggle="collapse" data-bs-target={"#" + submenuId} aria-expanded="true">
        <span>
          <span className="sidebar-icon"><FontAwesomeIcon icon={obj.icon} /></span>
          {props.obj.name}
        </span>
        <span className="link-arrow"><FontAwesomeIcon icon={faChevronRight} /></span>
      </span>
      <div id={submenuId} className="multi-level collapse show" role="list" >
        <ul className="flex-column nav">
          {
            obj.sidebarItems.map((val, k) => {
              return <SidebarItem key={k} obj={val} />;
            })
          }
        </ul>
      </div>
    </li>
  );
}

function SidebarItem(props) {
  const { obj } = props;
  return (
    <li className="nav-item">
      <Link id={obj.id} className="nav-link" to={obj.link}>{obj.name}</Link>
    </li>
  );
}

export function SidebarSmall(props) {
  return (
    <nav className="navbar navbar-dark navbar-theme-primary px-4 col-12 d-md-none">
      <img className="navbar-brand-dark" src="/img/expolon-logo-text-light.svg" alt="" />
      <div className="d-flex align-items-center">
        <button className="navbar-toggler d-md-none collapsed" type="button" data-toggle="collapse" data-target="#sidebarMenu" aria-controls="sidebarMenu" aria-expanded="false" aria-label="Toggle navigation">
          <span className="navbar-toggler-icon"></span>
        </button>
      </div>
    </nav>
  );
}
